import { ReactNode } from 'react'

import { cn } from '@shared/lib/cn'

import styles from './styles.module.scss'

interface ContentAreaContainerProps {
  children: ReactNode;
  className?: string;
}

export default function ContentAreaContainer (props: ContentAreaContainerProps) {
  const { children, className = '' } = props
  return <div className={cn(styles.root, className)}>{children}</div>
}
